import React, { useEffect, useState } from 'react'
import logo from '../assets/logowbg.png';
import cm from '../assets/vj.jpg';
import tnwclogo from '../assets/tnwclogo.avif';
import tnwclogoTa from '../assets/tnwctalogo.jpeg'
import { EllipsisOutlined } from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import { BsTranslate } from "react-icons/bs";
import { Menu, Drawer, Button } from "antd";
import { useTranslation } from 'react-i18next';
import { BASE_API } from '../Config/Config';
import { fetchannouncementapi } from '../api/fetchannouncementapi';

function Navbar() {
    const [openDrawer, setOpenDrawer] = useState(false);

    const [announcementData, setAnnouncementData] = useState([]);

    const location = useLocation();
    const navigate = useNavigate();
    const [showLoginModal, setShowLoginModal] = useState(false);
    const { t, i18n } = useTranslation();

    const items = [
        {
            key: "/",
            label: t("home"),
            onClick: () => navigate("/"),
        },

        // About Dropdown
        {
            key: "about",
            label: t("about"),
            children: [
                {
                    key: "/about/board-directors",
                    label: t("boardOfDirectors"),
                    onClick: () => navigate("/about/board-directors"),
                },
                {
                    key: "/about/organizational-structure",
                    label: t("organizationalStructure"),
                    onClick: () => navigate("/about/organizational-structure"),
                },
                {
                    key: "/about/head-office",
                    label: t("headOffice"),
                    onClick: () => navigate("/about/head-office"),
                },
                {
                    key: "/about/regional-offices",
                    label: t("regionalOffices"),
                    onClick: () => navigate("/about/regional-offices"),
                },
                {
                    key: "/about/warehouse-offices",
                    label: t("warehouseOffices"),
                    onClick: () => navigate("/about/warehouse-offices"),
                },
            ],
        },

        {
            key: "/statistics",
            label: t("statistics"),
            onClick: () => navigate("/statistics"),
        },
        {
            key: "/services",
            label: t("services"),
            onClick: () => navigate("/services"),
        },
        {
            key: "/tenders",
            label: t("tenders"),
            onClick: () => navigate("/tenders"),
        },
        {
            key: "/rti",
            label: t("rti"),
            onClick: () => navigate("/rti"),
        },
        {
            key: "/gallery",
            label: t("gallery"),
            onClick: () => navigate("/gallery"),
        },
        {
            key: "/other-links",
            label: t("otherLinks"),
            onClick: () => navigate("/other-links"),
        },


        {
            key: "/contact-us",
            label: t("contact"),
            onClick: () => navigate("/contact-us"),
        },
    ];

    // const [darkMode, setDarkMode] = useState(false);
    const [error, setError] = useState(false);
    const [Loading, setLoading] = useState(false);
    const [Signin, setSignin] = useState({
        username: "",
        password: ""
    });
    const [loginForm, setLoginForm] = useState(true);
    const [emailverification, setEmailVerification] = useState(false);
    const [enterOTP, setEnterOTP] = useState(false);
    const [otpTimer, setOtpTimer] = useState(120);
    const [canResendOtp, setCanResendOtp] = useState(false);
    const [resetPassword, setResetPassword] = useState(false);
    const [otp, setOtp] = useState(["", "", "", ""]);
    const [reset, setReset] = useState({
        email: "",
        userId: "",
        token: "",
        otp: "",
        password: "",
        confirmPassword: ""
    })

    const [resetPasswordError, setresetPasswordError] = useState(false)

    const handleForgotPassword = () => {
        setEmailVerification(true);
        setLoginForm(false);
    };

    const sendOtp = async () => {
        try {
            const formData = new FormData();

            formData.append("user_id", reset?.userId || "");
            formData.append("phone_email", reset?.email || "");

            const response = await fetch(
                `${BASE_API}/apis/loginforgotpass.php`,
                {
                    method: "POST",
                    body: formData,
                }
            );

            const data = await response.json();

            if (data?.message === "OTP sent successfully") {
                setReset((prev) => ({
                    ...prev,
                    otp: data?.data?.otp,
                    token: data?.data?.iv,
                }));

                setresetPasswordError(false);

                return true;
            } else {
                console.log("API Error:", data);
                setresetPasswordError(data?.message);

                return false;
            }
        } catch (error) {
            console.error("OTP Error:", error);
            return false;
        }
    };

    const SumbitEmailVerification = async (e) => {
        e.preventDefault();

        try {
            setLoading(true);

            const data = await sendOtp();
            if (data === true) {

                setOtpTimer(120);
                setCanResendOtp(false);

                setEnterOTP(true);
                setEmailVerification(false);
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleResendOtp = async () => {
        try {
            setLoading(true);

            const data = await sendOtp();

            if (data === true) {
                setOtpTimer(120);
                setCanResendOtp(false);
            }
        } catch (error) {
            console.error("Resend OTP Error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!enterOTP) return;

        if (otpTimer <= 0) {
            setCanResendOtp(true);
            return;
        }

        const timer = setInterval(() => {
            setOtpTimer((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [otpTimer, enterOTP]);

    const SumbitOTP = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);

            const enterOtp = Array.isArray(otp)
                ? otp.join("")
                : otp;

            const formData = new FormData();

            formData.append("enterotp", enterOtp || "");
            formData.append("sendotp", reset?.otp || "");
            formData.append("iv", reset?.token || "");

            const response = await fetch(
                `${BASE_API}/apis/verifyotp.php`,
                {
                    method: "POST",
                    body: formData,
                }
            );

            const data = await response.json();
            if (data?.status === "success") {
                setLoginForm(false);
                setEmailVerification(false);
                setEnterOTP(false);
                setResetPassword(true);
                setOtpTimer(120);
                setCanResendOtp(false);
                setOtp(["", "", "", ""]);
            } else {
                console.log(data?.message);
                setresetPasswordError(data?.message)
            }

        } catch (error) {
            console.error("OTP verification error:", error);
        } finally {
            setLoading(false);
        }
    };

    const SumbitResetPassword = async (e) => {
        e.preventDefault();

        // Get values
        const password = reset?.password || "";
        const confirmPassword = reset?.confirmPassword || "";

        // -----------------------------
        // Password validation
        // -----------------------------

        if (!password) {
            setPasswordError("Please enter your password");
            return;
        }

        if (password.length < 8) {
            setPasswordError("Password must be at least 8 characters");
            return;
        }

        if (!/[A-Z]/.test(password)) {
            setPasswordError(
                "Password must contain at least one uppercase letter"
            );
            return;
        }

        if (!/[a-z]/.test(password)) {
            setPasswordError(
                "Password must contain at least one lowercase letter"
            );
            return;
        }

        if (!/[0-9]/.test(password)) {
            setPasswordError(
                "Password must contain at least one number"
            );
            return;
        }

        if (!/[!@#$%^&*(),.?":{}|<>_\-\\[\]\/`~;'+=]/.test(password)) {
            setPasswordError(
                "Password must contain at least one special character"
            );
            return;
        }

        // Clear password error
        setPasswordError("");

        // -----------------------------
        // Confirm password validation
        // -----------------------------

        if (!confirmPassword) {
            setresetPasswordError("Please confirm your password");
            return;
        }

        if (password !== confirmPassword) {
            setresetPasswordError("Passwords do not match");
            return;
        }
        setresetPasswordError("");

        try {
            setLoading(true);

            const formData = new FormData();

            console.log(reset?.userId);

            formData.append("type", "user");
            formData.append("user_id", reset?.userId || "");
            formData.append("password", password);

            const response = await fetch(
                `${BASE_API}/apis/modifyuser.php`,
                {
                    method: "POST",
                    body: formData,
                }
            );

            const data = await response.json();

            console.log("Reset Password Response:", data);

            if (data?.message === "Password updated successfully") {
                setResetPassword(false);
                setLoginForm(true);

                setReset({
                    email: "",
                    userId: "",
                    token: "",
                    otp: "",
                    password: "",
                    confirmPassword: ""
                });

                setPasswordError("");
                setresetPasswordError("");
            } else {
                console.log("API Error:", data);
            }
        } catch (error) {
            console.error("Reset password error:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchAnnouncements = async () => {
        const data = await fetchannouncementapi();
        setAnnouncementData(data);
    }

    useEffect(() => {
        fetchAnnouncements();
    }, [fetchannouncementapi])

    const handleHomePage = () => {
        navigate("/")
    }

    const handleZoomIn = () => {
        document.body.style.zoom = "110%";
    };

    const handleZoomOut = () => {
        document.body.style.zoom = "90%";
    };


    const handlelogin = async (e) => {
        e.preventDefault();

        if (!Signin?.username || !Signin?.password) {
            alert(t("allFieldsMandatory"));
            return;
        }

        setLoading(true);

        try {
            const formData = new FormData();
            formData.append("user_id", Signin.username);
            formData.append("password", Signin.password);

            const response = await fetch(`${BASE_API}/apis/login.php`, {
                method: "POST",
                credentials: "include",
                body: formData,
            });

            const data = await response.json();

            if (data?.status === "success") {
                setSignin({
                    username: "",
                    password: ""
                });
                setShowLoginModal(false);
                setError(false);

                const UserData = {
                    id: data?.data[0]?.id,
                    role: data?.data[0]?.role,
                    name: data?.data[0]?.name,
                    user_id: data?.data[0]?.user_id,
                };
                const login = {
                    isLoggedIn: true,
                    token: data?.data[0]?.token,
                    valid: data?.data[0]?.expires_at
                };

                if (data?.data[0]?.role === "Manager") {
                    navigate("/warehouse-dashboard");
                    sessionStorage.setItem("userdetails", JSON.stringify(UserData || {}));
                    sessionStorage.setItem("loginCredential", JSON.stringify(login || {}));
                } else if (data?.data[0]?.role === "Admin") {
                    navigate("/warehouse-Admin");
                    sessionStorage.setItem("userdetails", JSON.stringify(UserData || {}));
                    sessionStorage.setItem("loginCredential", JSON.stringify(login || {}));
                } else {
                    navigate("/");
                    alert(t("unauthorizedUser"));
                }
                // Too many failed login attempts. Your account has been locked for 15 minutes.
            } else if (data?.message === "Account is temporarily locked. Please try again later.") {
                console.log(
                    `Too many failed login attempts. Please try again later. after login ${data?.reset_time}`
                );

                setError(t("accountTemporarilyLocked", {
                    resetTime: data?.reset_time
                }));
            } else {
                console.log("Login failed");
                setError(t("invalidCredentials"));
            }

        } catch (error) {
            console.error("Login Error:", error);
            setError(t("loginError"));
            console.error("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    // const handleLogout = () => {
    //     sessionStorage.removeItem("userdetails");
    //     sessionStorage.removeItem("loginCredential");
    //     navigate("/");
    // }

    const [passwordError, setPasswordError] = useState("");

    const validatePassword = (password) => {
        if (!password) {
            return "";
        }

        if (password.length < 8) {
            return "Password must be at least 8 characters";
        }

        if (!/[A-Z]/.test(password)) {
            return "Password must contain at least one uppercase letter";
        }

        if (!/[a-z]/.test(password)) {
            return "Password must contain at least one lowercase letter";
        }

        if (!/[0-9]/.test(password)) {
            return "Password must contain at least one number";
        }

        if (!/[!@#$%^&*(),.?":{}|<>_\-\\[\]\/`~;'+=]/.test(password)) {
            return "Password must contain at least one special character";
        }

        return "";
    };


    const handleLogout = async () => {
        try {

            const response = await fetch(`${BASE_API}/apis/logout.php`, {
                method: "POST",
                credentials: "include"
            });

            const data = await response.json();

            sessionStorage.removeItem("userdetails");
            sessionStorage.removeItem("loginCredential");

            if (data?.status === "success") {
                navigate("/");
            } else {
                navigate("/");
            }

        } catch (error) {

            console.error("Logout error:", error);

            sessionStorage.removeItem("userdetails");
            sessionStorage.removeItem("loginCredential");

            navigate("/");
        }
    };

    const storedData = JSON.parse(sessionStorage.getItem("loginCredential"));
    const isLoggedIn = storedData?.isLoggedIn === true;

    const changeLanguage = () => {
        const newLang = i18n.language === "en" ? "ta" : "en";
        sessionStorage.setItem("language", newLang);
        i18n.changeLanguage(newLang);
    };

    useEffect(() => {
        const savedLang = sessionStorage.getItem("language") || "en";
        i18n.changeLanguage(savedLang);
    }, []);

    return (
        <>
            <nav className="bg-white border-bottom py-2">
                <div className="container-fluid">

                    <div className="d-flex justify-content-end align-items-center gap-3">

                        {/* Light / Dark Mode */}
                        {/* <button
                            className="btn btn-sm p-0 border-0 text-dark"
                            title="Light / Dark"
                            onClick={() => setDarkMode(!darkMode)}
                        >
                            {darkMode ? (
                                <i className="bi bi-sun-fill fs-6"></i>
                            ) : (
                                <i className="bi bi-moon-fill fs-6"></i>
                            )}
                        </button> */}


                        {/* Skip To Main Content */}
                        <button
                            className="btn btn-sm p-0 border-0 text-dark small"
                            onClick={handleHomePage}
                        >
                            {t("skipToMainContent")}
                        </button>


                        {/* Zoom In */}
                        <button
                            className="btn btn-sm p-0 border-0 text-dark"
                            title="Zoom In"
                            onClick={handleZoomIn}
                        >
                            <i className="bi bi-zoom-in fs-6"></i>
                        </button>


                        {/* Zoom Out */}
                        <button
                            className="btn btn-sm p-0 border-0 text-dark"
                            title="Zoom Out"
                            onClick={handleZoomOut}
                        >
                            <i className="bi bi-zoom-out fs-6"></i>
                        </button>


                        {/* Screen Recorder */}
                        <button
                            onClick={() => navigate("/screen-reader")}
                            className="btn btn-sm p-0 border-0 text-dark d-flex align-items-center gap-1 small"
                        >
                            <i className="bi bi-record-circle fs-6"></i>
                            {t("screenReader")}
                        </button>


                        {/* Translate */}
                        <button
                            title="Translate"
                            onClick={changeLanguage}
                            className="btn btn-sm p-0 border-0 text-dark"
                        >
                            <i className="bi bi-translate fs-6"></i>
                        </button>
                    </div>

                </div>
            </nav>

            {/* Top Navbar: Images */}
            <nav className="navbar-expand-lg shadow-sm py-2">
                <div className="container d-flex flex-column flex-lg-row justify-content-between align-items-center text-center text-lg-start">

                    {/* Left Section */}
                    <div className="d-flex flex-column flex-md-row align-items-center gap-2">
                        <img
                            src={i18n?.language === "ta" ? tnwclogoTa : tnwclogo}
                            alt="Tamil Nadu Warehousing Logo"
                            style={{ height: "80px", width: "auto" }}
                        />

                        <div className="brand-text">
                            <div className="fw-bold fs-6 lh-1" style={{ color: "#0A2158" }}>
                                தமிழ்நாடு சேமிப்புக் கிடங்கு நிறுவனம்
                            </div>

                            <div className="fw-normal small text-danger mb-1">
                                (தமிழக அரசு சார்பு நிறுவனம்)
                            </div>

                            <div className="fw-bold fs-6 lh-1" style={{ color: "#0A2158" }}>
                                TAMIL NADU WAREHOUSING CORPORATION
                            </div>

                            <div className="fw-normal small text-danger">
                                (A Government of Tamil Nadu Sponsored Undertaking)
                            </div>
                        </div>
                    </div>

                    {/* Right Section */}
                    <div className="d-flex flex-column flex-md-row align-items-center gap-3 mt-3 mt-lg-0">

                        <img
                            src={logo}
                            alt="Tamil Nadu Logo"
                            style={{ height: "80px", width: "auto" }}
                        />

                        <div className="text-center text-md-end">
                            <h6 className="mb-1 fw-bold text-primary">{t("chiefMinisterName")}</h6>
                            <p
                                className="mb-0 text-muted small fst-italic"
                                style={{ whiteSpace: "nowrap", fontSize: ".8rem" }}
                            >
                                {t("chiefMinisterRole")}
                            </p>
                            <p
                                className="mb-0 text-muted small fst-italic"
                                style={{ whiteSpace: "nowrap", fontSize: ".8rem" }}
                            >
                                {t("governmentOfTamilNadu")}
                            </p>

                        </div>


                        <img
                            src={cm}
                            alt="cm"
                            className="rounded-circle"
                            style={{
                                height: "100px",
                                width: "100px",
                                objectFit: "cover",
                                objectPosition: "center top",
                                borderRadius: "50%",
                                border: "3px solid #0d6efd"
                            }}
                        />
                    </div>

                </div>
            </nav>

            {announcementData.length !== 0 && (
                <nav className="navbar navbar-expand-lg py-0">
                    <div className='container-fluid' style={{ backgroundColor: "#0056b3", color: "white", height: "40px" }}>

                        <div className="container d-flex align-items-center">
                            {/* Left fixed label */}
                            <div
                                className="d-flex align-items-center px-3 py-0 my-0 fw-bold text-dark"
                                style={{ backgroundColor: "#d3dce6", whiteSpace: "nowrap" }}
                            >
                                {t("newsAnnouncements")}
                            </div>

                            {/* Scrolling news */}
                            <div
                                className="flex-grow-1 overflow-hidden"
                                style={{ whiteSpace: "nowrap", position: "relative" }}
                            >
                                <div
                                    className="d-inline-block"
                                    style={{
                                        animation: "scroll-left 20s linear infinite",
                                        paddingLeft: "100%",
                                    }}
                                >
                                    {announcementData.map((item, idx) => (
                                        <span
                                            key={idx}
                                            className="px-4 fw-semibold text-white"
                                            style={{ whiteSpace: "nowrap" }}
                                        >
                                            <i className="bi bi-circle-fill me-2 text-warning"></i>{i18n.language === "ta" ? item?.ta_news : item?.en_news}
                                        </span>
                                    ))}
                                </div>
                            </div>



                            {/* <Translate /> */}
                            {/* Inline keyframes animation */}
                            <style>{`
                        @keyframes scroll-left {
                            0% { transform: translateX(0); }
                            100% { transform: translateX(-100%); }
                        }
                    `}</style>
                        </div>
                    </div>
                </nav>
            )}

            <nav className="navbar navbar-expand-lg w-100" style={{ zIndex: 10, backgroundColor: "#0A2158" }}>

                <div className="container">

                    {/* Logo */}
                    <div className="d-flex align-items-center">
                        <a className="navbar-brand text-white fw-bold fs-2 mb-0">TNWC</a>
                    </div>


                    {/* Desktop Menu */}
                    {!isLoggedIn && (
                        <div
                            className="d-none d-lg-flex flex-grow-1 justify-content-center"
                            style={{ minWidth: 0 }}
                        >
                            <Menu
                                mode="horizontal"
                                items={items}
                                theme="dark"
                                triggerSubMenuAction="hover"
                                selectedKeys={[location.pathname]}
                                overflowedIndicator={
                                    <EllipsisOutlined
                                        style={{
                                            color: "white"
                                        }}
                                    />
                                }
                                style={{
                                    backgroundColor: "transparent",
                                    borderBottom: "none",
                                    width: "100%",
                                    justifyContent: "center",
                                }}
                            />
                        </div>
                    )}



                    {/* Right Side */}
                    <div className="d-flex align-items-center gap-2">


                        {/* Mobile Menu Button */}
                        {!isLoggedIn && (
                            <Button
                                className="d-lg-none"
                                type="text"
                                icon={
                                    <i
                                        className="bi bi-list"
                                        style={{
                                            color: "white",
                                            fontSize: "22px"
                                        }}
                                    />
                                }
                                onClick={() => setOpenDrawer(true)}
                            />
                        )}



                        {/* Login / Logout */}
                        {isLoggedIn ? (
                            <button
                                className="btn btn-outline-light px-3"
                                onClick={handleLogout}
                            >
                                {t("logout")}
                            </button>
                        ) : (
                            <button
                                className="btn btn-outline-light px-3"
                                onClick={() =>
                                    setShowLoginModal(true)
                                }
                            >
                                {t("login")}
                            </button>
                        )}

                    </div>

                </div>

                {/* Mobile Drawer */}
                <Drawer
                    title="Menu"
                    placement="right"
                    onClose={() => setOpenDrawer(false)}
                    open={openDrawer}
                >
                    <Menu
                        mode="inline"
                        items={items}
                        selectedKeys={[location.pathname]}
                        onClick={({ key }) => {
                            setOpenDrawer(false);
                        }}
                    />
                </Drawer>
            </nav>


            {showLoginModal && (
                <div
                    className="modal fade show"
                    style={{
                        display: "block",
                        backgroundColor: "rgba(0,0,0,0.6)",
                        backdropFilter: "blur(5px)"
                    }}
                    tabIndex="-1"
                    onClick={() => setShowLoginModal(false)}
                >
                    <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                        <div
                            className="modal-content border-0 shadow-lg"
                            style={{
                                borderRadius: "16px",
                                overflow: "hidden"
                            }}
                        >

                            {loginForm && (
                                <>
                                    {/* Header */}
                                    <div div className="modal-header border-0 pb-0 position-relative justify-content-center">

                                        <div className="text-center">
                                            <h4 className="fw-bold mb-1">{t("welcomeBack")}</h4>
                                            <small className="text-muted">
                                                {t("pleaseLogin")}
                                            </small>
                                        </div>

                                        <button
                                            type="button"
                                            className="btn-close position-absolute end-0 me-3"
                                            onClick={() => setShowLoginModal(false)}
                                        />

                                    </div>

                                    {/* Body */}
                                    <div className="modal-body pt-3 px-4">

                                        <form onSubmit={handlelogin}>

                                            {/* Username */}
                                            <div className="mb-3">
                                                <label className="form-label fw-semibold text-primary">
                                                    <i className="bi bi-person-fill"></i> {t("username")}
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={t("enterUsername")}
                                                    value={Signin?.username}
                                                    onChange={(e) =>
                                                        setSignin((pv) => ({
                                                            ...pv,
                                                            username: e.target.value
                                                        }))
                                                    }
                                                    disabled={Loading}
                                                    required
                                                    style={{
                                                        borderRadius: "10px"
                                                    }}
                                                />
                                            </div>

                                            {/* Password */}
                                            <div className="mb-4">
                                                <label className="form-label fw-semibold text-primary">
                                                    <i className="bi bi-eye-slash-fill"></i> {t("password")}
                                                </label>
                                                <input
                                                    type="password"
                                                    className="form-control"
                                                    placeholder={t("enterPassword")}
                                                    value={Signin?.password}
                                                    onChange={(e) =>
                                                        setSignin((pv) => ({
                                                            ...pv,
                                                            password: e.target.value
                                                        }))
                                                    }
                                                    disabled={Loading}
                                                    required
                                                    style={{
                                                        borderRadius: "10px"
                                                    }}
                                                />
                                            </div>

                                            {error && (
                                                <div className="alert alert-danger py-2">
                                                    {error}
                                                </div>
                                            )}

                                            {/* Login Button */}
                                            <div className="d-flex justify-content-between">

                                                <button
                                                    type="button"
                                                    disabled={Loading}
                                                    onClick={handleForgotPassword}
                                                    className="btn border-0 p-0 d-flex align-items-center gap-2 fw-semibold"
                                                    style={{
                                                        color: "#1d4ed8",
                                                        background: "transparent",
                                                        fontSize: "14px",
                                                        transition: "all 0.2s ease",
                                                        cursor: Loading ? "not-allowed" : "pointer",
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.color = "#0A2158";
                                                        e.currentTarget.style.textDecoration = "underline";
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.color = "#1d4ed8";
                                                        e.currentTarget.style.textDecoration = "none";
                                                    }}
                                                >
                                                    <i className="bi bi-shield-lock"></i>
                                                    {t("forgotpassword")}
                                                </button>

                                                <button
                                                    disabled={Loading}
                                                    type="submit"
                                                    className="btn fw-semibold text-end"
                                                    style={{
                                                        background: "linear-gradient(135deg,#0A2158,#1d4ed8)",
                                                        color: "white",
                                                        padding: "12px",
                                                        borderRadius: "10px",
                                                        fontSize: "16px"
                                                    }}
                                                >
                                                    {Loading ? t("signingIn") : t("login")}
                                                </button>

                                            </div>
                                        </form>

                                    </div>
                                </>
                            )}

                            {/* forgot password */}
                            {emailverification && (
                                <div className="modal-body pt-3 px-4">

                                    <div div className="modal-header border-0 pb-0 position-relative justify-content-between">

                                        <div className="text-center">
                                            <h4 className="fw-bold mb-1 text-decoration-underline" style={{ color: "#0d6efd" }}>{t("resetpassword")}</h4>
                                        </div>

                                        <button
                                            type="button"
                                            disabled={Loading}
                                            onClick={() => { setEmailVerification(false); setLoginForm(true); }}
                                            className="btn fw-semibold"
                                            style={{
                                                color: "#0A2158",
                                                background: "#f8fafc",
                                                border: "1px solid #d1d5db",
                                                borderRadius: "10px",
                                                padding: "10px 16px",
                                                fontSize: "14px",
                                            }}
                                        >
                                            <i className="bi bi-arrow-left me-2"></i>
                                            {t("backtologin")}
                                        </button>
                                    </div>

                                    <form onSubmit={SumbitEmailVerification}>

                                        {/* userid */}
                                        <div className="mb-4">
                                            <label className="form-label fw-semibold text-primary">
                                                <i className="bi bi-person-fill me-2"></i>
                                                {t("username")}
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder={t("enterUsername")}
                                                value={reset?.userId || ""}
                                                onChange={(e) =>
                                                    setReset((pv) => ({
                                                        ...pv,
                                                        userId: e.target.value
                                                    }))
                                                }
                                                disabled={Loading}
                                                required
                                                style={{
                                                    borderRadius: "10px",
                                                    padding: "12px"
                                                }}
                                            />
                                        </div>

                                        {/* Email */}
                                        <div className="mb-4">
                                            <label className="form-label fw-semibold text-primary">
                                                <i className="bi bi-envelope-fill me-2"></i>
                                                {t("email")}
                                            </label>

                                            <input
                                                type="email"
                                                className="form-control"
                                                placeholder={t("enterEmail")}
                                                value={reset?.email || ""}
                                                onChange={(e) =>
                                                    setReset((pv) => ({
                                                        ...pv,
                                                        email: e.target.value
                                                    }))
                                                }
                                                disabled={Loading}
                                                required
                                                style={{
                                                    borderRadius: "10px",
                                                    padding: "12px"
                                                }}
                                            />
                                        </div>

                                        {resetPasswordError && (
                                            <div className="alert alert-danger py-2">
                                                {resetPasswordError}
                                            </div>
                                        )}


                                        {/* Button */}
                                        <button
                                            type="submit"
                                            disabled={Loading}
                                            className="btn w-100 fw-semibold"
                                            style={{
                                                background:
                                                    "linear-gradient(135deg,#0A2158,#1d4ed8)",
                                                color: "white",
                                                padding: "12px",
                                                borderRadius: "10px",
                                                fontSize: "16px",
                                                border: "none"
                                            }}
                                        >
                                            {Loading ? (
                                                <>
                                                    <span
                                                        className="spinner-border spinner-border-sm me-2"
                                                        role="status"
                                                    ></span>
                                                    {t("sending")}
                                                </>
                                            ) : (
                                                <>
                                                    <i className="bi bi-send-fill me-2"></i>
                                                    {t("sendVerificationCode")}
                                                </>
                                            )}
                                        </button>

                                    </form>
                                </div>
                            )}


                            {/* enterotp */}
                            {enterOTP && (
                                <div className="modal-body pt-3 px-4">

                                    <form onSubmit={SumbitOTP}>

                                        {/* Title */}
                                        <div className="text-center mb-4">
                                            <h5
                                                className="fw-bold mb-0"
                                                style={{
                                                    color: "#0A2158",
                                                    textDecoration: "underline",
                                                    fontSize: "20px",
                                                }}
                                            >
                                                {t("enterOTP")}
                                            </h5>
                                        </div>

                                        {/* Email Message */}
                                        <div className="text-center mb-2">
                                            <p
                                                className="mb-0"
                                                style={{
                                                    fontSize: "13px",
                                                    lineHeight: "1.5",
                                                    color: "#333",
                                                }}
                                            >
                                                {t("otpsmalltext")}
                                                <br />

                                                <strong
                                                    style={{
                                                        color: "#0A2158",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    {reset?.email}
                                                </strong>{" "}
                                                {t("otpemail")}
                                            </p>
                                        </div>

                                        {/* Timer / Resend */}
                                        {!canResendOtp ? (
                                            <div className="text-center mb-3">
                                                <span
                                                    style={{
                                                        fontSize: "14px",
                                                        fontWeight: "600",
                                                        color: "#333",
                                                    }}
                                                >
                                                    {t("expiresIn")}:{" "}
                                                    <strong style={{ color: "#dc0000" }}>
                                                        {String(
                                                            Math.floor(otpTimer / 60)
                                                        ).padStart(2, "0")}
                                                        :
                                                        {String(
                                                            otpTimer % 60
                                                        ).padStart(2, "0")}
                                                    </strong>
                                                </span>
                                            </div>
                                        ) : (
                                            <div className="text-center mb-3">
                                                <span
                                                    className="text-muted"
                                                    style={{ fontSize: "13px" }}
                                                >
                                                    {t("didntReceiveOtp")}
                                                </span>

                                                <button
                                                    type="button"
                                                    onClick={handleResendOtp}
                                                    disabled={Loading}
                                                    className="btn btn-link p-0 ms-1 fw-semibold"
                                                    style={{
                                                        color: "#1d4ed8",
                                                        textDecoration: "none",
                                                        fontSize: "13px",
                                                    }}
                                                >
                                                    <i className="bi bi-arrow-clockwise me-1"></i>
                                                    {t("resendOtp")}
                                                </button>
                                            </div>
                                        )}

                                        {/* OTP Inputs */}
                                        <div
                                            className="d-flex justify-content-center gap-2 mb-3"
                                        >
                                            {[0, 1, 2, 3].map((index) => (
                                                <input
                                                    key={index}
                                                    type="text"
                                                    inputMode="numeric"
                                                    maxLength="1"
                                                    disabled={canResendOtp || Loading}
                                                    value={otp?.[index] || ""}
                                                    onChange={(e) => {
                                                        const value = e.target.value.replace(
                                                            /[^0-9]/g,
                                                            ""
                                                        );

                                                        setOtp((prev) => {
                                                            const newOtp = [...prev];
                                                            newOtp[index] = value;
                                                            return newOtp;
                                                        });

                                                        // Move to next input
                                                        if (value && index < 3) {
                                                            document
                                                                .getElementById(`otp-${index + 1}`)
                                                                ?.focus();
                                                        }
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (
                                                            e.key === "Backspace" &&
                                                            !otp?.[index] &&
                                                            index > 0
                                                        ) {
                                                            document
                                                                .getElementById(`otp-${index - 1}`)
                                                                ?.focus();
                                                        }
                                                    }}
                                                    id={`otp-${index}`}
                                                    required
                                                    style={{
                                                        width: "50px",
                                                        height: "50px",
                                                        borderRadius: "8px",
                                                        border: "1px solid #ddd",
                                                        background: "#eeeeee",
                                                        textAlign: "center",
                                                        fontSize: "20px",
                                                        fontWeight: "600",
                                                        outline: "none",
                                                    }}
                                                />
                                            ))}
                                        </div>

                                        {resetPasswordError && (
                                            <div className="alert alert-danger py-2">
                                                {resetPasswordError}
                                            </div>
                                        )}

                                        {/* Verify Button */}
                                        <div className='d-flex justify-content-center align-items-center fw-semibold'>
                                            <button
                                                type="submit"
                                                disabled={canResendOtp || Loading}
                                                className="btn fw-semibold"
                                                style={{
                                                    background:
                                                        "linear-gradient(135deg,#0A2158,#1d4ed8)",
                                                    color: "white",
                                                    padding: "8px",
                                                    borderRadius: "10px",
                                                    fontSize: "16px",
                                                    border: "none"
                                                }}
                                            >
                                                {Loading ? (
                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm me-2"
                                                            role="status"
                                                        ></span>
                                                        {t("verifying")}
                                                    </>
                                                ) : (
                                                    t("verify")
                                                )}
                                            </button>
                                        </div>


                                    </form>
                                </div>
                            )}

                            {/* set password */}
                            {resetPassword && (
                                <div className="modal-body pt-3 px-4">

                                    <div div className="modal-header border-0 pb-0 position-relative justify-content-center">

                                        <div className="text-center">
                                            <h4 className="fw-bold mb-1 text-decoration-underline" style={{ color: "#0d6efd" }}>{t("resetpassword")}</h4>
                                        </div>
                                    </div>

                                    <form onSubmit={SumbitResetPassword}>
                                        {/* New Password */}
                                        <div className="mb-4">
                                            <label className="form-label fw-semibold text-primary">
                                                <i className="bi bi-lock-fill me-2"></i>
                                                {t("newpassword")}
                                            </label>

                                            <input
                                                type="password"
                                                className={`form-control`}
                                                placeholder={t("enterPassword")}
                                                value={reset?.password || ""}
                                                onChange={(e) => {
                                                    const password = e.target.value;

                                                    setReset((pv) => ({
                                                        ...pv,
                                                        password: password
                                                    }));

                                                    const error = validatePassword(password);
                                                    setPasswordError(error);

                                                    // Also re-check confirm password
                                                    if (
                                                        reset?.confirmPassword &&
                                                        reset.confirmPassword !== password
                                                    ) {
                                                        setresetPasswordError("Passwords do not match");
                                                    } else {
                                                        setresetPasswordError("");
                                                    }
                                                }}
                                                disabled={Loading}
                                                required
                                                style={{
                                                    borderRadius: "10px",
                                                    padding: "12px"
                                                }}
                                            />

                                            {/* Password validation message */}
                                            {/* {passwordError && (
                                                <div className="invalid-feedback">
                                                    {passwordError}
                                                </div>
                                            )} */}


                                        </div>

                                        {/* Confirm Password */}
                                        <div className="mb-1">
                                            <label className="form-label fw-semibold text-primary">
                                                <i className="bi bi-lock-fill me-2"></i>
                                                {t("confirmpassword")}
                                            </label>

                                            <input
                                                type="password"
                                                className={`form-control ${resetPasswordError ? "is-invalid" : ""
                                                    }`}
                                                placeholder={t("enterConfirmPassword")}
                                                value={reset?.confirmPassword || ""}
                                                onChange={(e) => {
                                                    const confirmPassword = e.target.value;

                                                    setReset((pv) => ({
                                                        ...pv,
                                                        confirmPassword: confirmPassword
                                                    }));

                                                    if (confirmPassword !== reset?.password) {
                                                        setresetPasswordError("Passwords do not match");
                                                    } else {
                                                        setresetPasswordError("");
                                                    }
                                                }}
                                                disabled={Loading}
                                                required
                                                style={{
                                                    borderRadius: "10px",
                                                    padding: "12px"
                                                }}
                                            />

                                            {resetPasswordError && (
                                                <div className="invalid-feedback">
                                                    {resetPasswordError}
                                                </div>
                                            )}
                                        </div>

                                        {/* Password requirements */}
                                        <div className="mb-2 small">
                                            <strong>{t("passwordRequirementTitle")}</strong>
                                            <div
                                                className={
                                                    reset?.password?.length >= 8
                                                        ? "text-success"
                                                        : "text-muted"
                                                }
                                            >

                                                <i
                                                    className={
                                                        reset?.password?.length >= 8
                                                            ? "bi bi-check-circle-fill me-1"
                                                            : "bi bi-circle me-1"
                                                    }
                                                ></i>
                                                {t("passwordMin")}
                                            </div>

                                            <div
                                                className={
                                                    /[A-Z]/.test(reset?.password || "")
                                                        ? "text-success"
                                                        : "text-muted"
                                                }
                                            >
                                                <i
                                                    className={
                                                        /[A-Z]/.test(reset?.password || "")
                                                            ? "bi bi-check-circle-fill me-1"
                                                            : "bi bi-circle me-1"
                                                    }
                                                ></i>
                                                {t("passwordUppercase")}
                                            </div>

                                            <div
                                                className={
                                                    /[a-z]/.test(reset?.password || "")
                                                        ? "text-success"
                                                        : "text-muted"
                                                }
                                            >
                                                <i
                                                    className={
                                                        /[a-z]/.test(reset?.password || "")
                                                            ? "bi bi-check-circle-fill me-1"
                                                            : "bi bi-circle me-1"
                                                    }
                                                ></i>
                                                {t("passwordLowercase")}
                                            </div>

                                            <div
                                                className={
                                                    /[0-9]/.test(reset?.password || "")
                                                        ? "text-success"
                                                        : "text-muted"
                                                }
                                            >
                                                <i
                                                    className={
                                                        /[0-9]/.test(reset?.password || "")
                                                            ? "bi bi-check-circle-fill me-1"
                                                            : "bi bi-circle me-1"
                                                    }
                                                ></i>
                                                {t("passwordNumber")}
                                            </div>

                                            <div
                                                className={
                                                    /[!@#$%^&*(),.?":{}|<>_\-\\[\]\/`~;'+=]/.test(
                                                        reset?.password || ""
                                                    )
                                                        ? "text-success"
                                                        : "text-muted"
                                                }
                                            >
                                                <i
                                                    className={
                                                        /[!@#$%^&*(),.?":{}|<>_\-\\[\]\/`~;'+=]/.test(
                                                            reset?.password || ""
                                                        )
                                                            ? "bi bi-check-circle-fill me-1"
                                                            : "bi bi-circle me-1"
                                                    }
                                                ></i>
                                                {t("passwordSpecial")}
                                            </div>
                                        </div>


                                        {/* {setresetPasswordError && (
                                            <small className="text-danger">
                                                {setresetPasswordError}
                                            </small>
                                        )} */}

                                        {/* Button */}
                                        <button
                                            type="submit"
                                            disabled={Loading}
                                            className="btn w-100 fw-semibold"
                                            style={{
                                                background:
                                                    "linear-gradient(135deg,#0A2158,#1d4ed8)",
                                                color: "white",
                                                padding: "12px",
                                                borderRadius: "10px",
                                                fontSize: "16px",
                                                border: "none"
                                            }}
                                        >
                                            {Loading ? (
                                                <>
                                                    <span
                                                        className="spinner-border spinner-border-sm me-2"
                                                        role="status"
                                                    ></span>
                                                    {t("sumbitting")}
                                                </>
                                            ) : (
                                                <>
                                                    <i className="bi bi-send-fill me-2"></i>
                                                    {t("changepassword")}
                                                </>
                                            )}
                                        </button>

                                    </form>
                                </div>
                            )}

                        </div>
                    </div>
                </div >
            )}
        </>
    );
}

export default Navbar


